/*=========================================================================================
  File Name: moduleScheduleActions.js
  Description: Schedule Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Api from "@/helpers/api.js";

export default {
	save({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.post("/repeat_frequency", payload)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	update({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.put(`/repeat_frequency/${payload.id}`, payload.items)
				.then((response) => {
					commit("UPDATE_FREQUENCY", response.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	frequencyFilter({commit}, data) {
		return new Promise((resolve, reject) => {
			const payload = {
				page: data.page || 1,
				quantity: data.quantity || 1000000,
				fields: [
					"id",
					"name",
					"description",
					"cron",
					"duration",
					"added_on",
					"update_on",
					"visit_point_id",
					"vehicle_id",
				],
				id: data.id || [],
				name: data.name || [],
				description: data.description || [],
				cron: data.cron || [],
				duration: data.duration || [],
				visit_point_id: data.visit_point_id || [],
				vehicle_id: data.vehicle_id || [],
				match_filter: data.match_filter,
				order_by: data.order_by || ["name"],
				sort: data.sort || "asc",
			};
			Api.post("/repeat_frequency/filter", payload)
				.then((res) => {
					if (data.assign) {
						commit("SET_ASSIGNED_FREQUENCY", res.data.records);
					} else {
						commit("SET_FREQUENCY", res.data.records);
					}
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	deleteById({commit}, id) {
		return new Promise((resolve, reject) => {
			Api.delete(`/repeat_frequency/${id}`)
				.then((response) => {
					commit("REMOVE_FREQUENCY", id);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	cleanEvents({commit}) {
		commit("CLEAN_EVENTS");
	},
};
